import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditStationsReport from "./components/ListAllAuditStationsReport";

export default function AuditStationsReportTable() {
    const { translate } = useLang();
    
    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Stations')}`} />
            <ListAllAuditStationsReport />
        </>
    )
}